import { ApiResponse } from "@api/apiRequest";
import { paymentGatewayApi } from "@api/instances";
import rollbar, { LogMetadata } from "@utils/rollbar";

export interface WinbackResult {
  redirectUrl: string;
}

const ZUORA_WINBACK_ENDPOINT = "/v3/promocodes/zuora/winback";

const renewZuoraSubscriptionWithWinbackCoupon = async (): Promise<ApiResponse<WinbackResult>> => {
  try {
    const response = await paymentGatewayApi.post(
      ZUORA_WINBACK_ENDPOINT,
      undefined,
      { requireAuth: true }
    );
    return { data: { redirectUrl: response.data?.redirectUrl ?? "" }, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: ZUORA_WINBACK_ENDPOINT, method: "POST" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error renewing subscription" };
  }
};

export default renewZuoraSubscriptionWithWinbackCoupon;
